module.exports = __webpack_public_path__ + "static/img/80_phase_function_Paper_Points.e6c6dad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/80_phase_function_Paper_Points.png
// module id = vPyG
// module chunks = 0